import React from "react";

function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
}

function toNumberOrZero(value) {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
}

function getRangeColor(ranges, percentage) {
    try {
        // console.log('ranges');
        // console.log(ranges);
        // console.log('percentage');
        // console.log(percentage);
        const p = percentage;

        const match =
            ranges.find((r) => p >= r.inicio && p < r.fin) ||
            ranges.find((r) => p === 100 && r.fin === 100) ||
            ranges[ranges.length - 1];

        return match ? match.color : "#0F3457";
    } catch (err) {
        console.log('getRangeColor err');
        console.log(err);
        return "#0F3457";
    }
}

export default function ProgressBarRangeComponent({
    percentage,
    ranges,
    height = 10,
    showLabel = true,
}) {
    const p = clamp(toNumberOrZero(percentage), 0, 100);
    const color = getRangeColor(ranges, p);

    return (
        <div className="flex items-center gap-2 min-w-[160px]">
            <div
                className="w-full bg-gray-200 rounded-full overflow-hidden"
                style={{ height }}
                role="progressbar"
                aria-valuenow={p}
                aria-valuemin={0}
                aria-valuemax={100}
            >
                <div
                    className="rounded-full transition-all duration-300"
                    style={{
                        width: `${p}%`,
                        height: "100%",
                        backgroundColor: color,
                    }}
                />
            </div>

            {showLabel && (
                <span className="text-xs font-medium tabular-nums w-[42px] text-right">
                    {Math.round(p)}%
                </span>
            )}
        </div>
    );
}
